<div class="center-outer">
  <div class="center-inner">
    <div class="row">
      <app-headertext text="Objektsøk"></app-headertext>
      <div class="fill-space"></div>
      <div *ngIf="page">
        <mat-button-toggle-group
          [value]="page.value"
          appearance="legacy"
          aria-label="Object search page selection"
          style="margin-top: 10px; margin-right: 10px; border-radius: 8px;">
          <mat-button-toggle
            [value]="pages[0].value"
            (click)="onPageChange(pages[0])">
            <mat-icon
              class="tab-icon"
            >
              {{ pages[0].icon }}
            </mat-icon>
            <span *ngIf="!mobileQuery.matches">QR</span>
          </mat-button-toggle>
          <mat-button-toggle
            [value]="pages[1].value"
            (click)="onPageChange(pages[1])">
            <mat-icon
              class="tab-icon"
            >
              {{ pages[1].icon }}
            </mat-icon>
            <span *ngIf="!mobileQuery.matches">Tekst</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <div class="project-title">
      <span style="font-size: 20px;">{{ projectId }}</span> - {{ projectName }}
    </div>
    <div>
      <mat-tab-group [(selectedIndex)]="keyIndex" mat-stretch-tabs="true"
                     (selectedIndexChange)="onKeyChange($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            Navn
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="pi pi-tag" class="tag"></i>
            TFM
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="pi pi-tag" class="tag"></i>
            RDS
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
    <app-object-qr-search
      *ngIf="
            page?.value === 'qr' &&
            projectId &&
            projectName
          "
      class="child-margin card-width"
      [projectId]="projectId"
      [projectName]="projectName"
      [objectsName]="objectsName"
      [objectsTfm]="objectsTfm"
      [objectsRds]="objectsRds"
      [warning]="warning"
      [key]="key"
    ></app-object-qr-search>
    <app-object-name-search
      *ngIf="
            page?.value === 'text' &&
            projectId &&
            projectName
          "
      class="child-margin card-width full-height"
      [projectId]="projectId"
      [projectName]="projectName"
      [objectsName]="objectsName"
      [objectsTfm]="objectsTfm"
      [objectsRds]="objectsRds"
      [key]="key"
    ></app-object-name-search>
  </div>
</div>
